<template>
  <div class="publisher-search-wrapper">
    <v-card flat :color="color" tile min-height="40" class="ma-0 pa-0">
      <v-card-text class="ma-0 pa-0">
        <v-combobox
          v-model="term_chips"
          small-chips
          :rounded="rounded"
          :solo="solo"
          clearable
          outlined
          dense
          label="Enter keywords (searches name, acronym, description)"
          multiple
          small
          ref="keywords"
          append-outer-icon="mdi-magnify"
          :dark="dark"
          @click:append-outer="search()"
          @click:clear="clearSearch()"
          class="search-combobox"
        >
          <template v-slot:selection="{ item, select, selected }">
            <v-chip
              color="primary"
              small
              label
              :input-value="selected"
              close
              @click="select"
              @click:close="remove_kw(item)"
              class="mr-1"
              >{{ item }}</v-chip
            >
          </template>
        </v-combobox>
      </v-card-text>
    </v-card>
    <div class="d-flex align-center pt-0 mt-0 mb-3">
      <div class="caption grey--text">Include in search</div>
      <v-checkbox
        v-model="include_description"
        label="Publisher Description"
        dense
        hide-details
        class="ma-0 pa-0 ml-2"
        style="flex: 0 0 auto;"
      ></v-checkbox>
    </div>
  </div>
</template>

<script>
import { bus } from "../main.js";
import { autocomplete, fetchProfile } from "./APIManager.js";
import { getArray } from "./Utils.js";

export default {
  props: {
    rounded: Boolean,
    solo: Boolean,
    dark: Boolean,
    color: String,
    govts: []
  },
  data() {
    return {
      term_chips: [],
      search_terms: "",
      items: [],
      isLoading: false,
      disable_nav: false,
      lookup_limit: 60,
      entity: {},
      include_description: true
      //show_login_menu: false
    };
  },

  mounted() {
    var query = this.$route.query;

    if (query.hasOwnProperty("term")) {
      this.term_chips = getArray(query["term"]);
    }
    
    if (query.hasOwnProperty("include_description")) {
      this.include_description = query.include_description === 'true' || query.include_description === true;
    } else {
      this.include_description = true; // Default to true
    }
  },

  watch: {
    search_terms(val) {
      val && val !== this.select && this.lookup(val);
    },

    govts: {
      handler() {
        ////////////console.log("IN TENDER RESULTS: ");
        if (this.govts && this.govts.length == 0){
          this.clearSearch();
        }
      },
      deep: true
    },
    
    '$route'(to, from) {
      // Update include_description from route
      if (to.query.include_description !== undefined) {
        this.include_description = to.query.include_description === 'true' || 
                                     to.query.include_description === true;
      }
      
      // Update term_chips from route
      if (to.query.term) {
        this.term_chips = getArray(to.query.term);
      } else {
        this.term_chips = [];
      }
    }
  },

  methods: {
    
    remove_kw(item) {
      this.term_chips.splice(this.term_chips.indexOf(item), 1);
      this.term_chips = [...this.term_chips];
      if (this.term_chips.length == 0){
        this.clearSearch()
      }
    },

    clearSearch() {

      this.term_chips = [];
      this.$emit("clearFilter", true);
    },

    search(){
      var qry = JSON.parse(JSON.stringify(this.$route.query));
      // Always remove previous term and reset page to ensure route change
      delete qry["term"];
      delete qry["page"];
      const page_num = 1;

      // Build query with search terms and flags
      const nextQuery = { ...qry, page: page_num };
      
      if (this.term_chips.length > 0) {
        nextQuery.term = this.term_chips;
      }
      
      // Include search flags
      nextQuery.include_description = this.include_description;

      // Emit search event to parent so it can handle filter merging and reload
      // This ensures reload happens even if route navigation fails
      this.$emit('search', nextQuery);

      // Always push to ensure route change triggers watchers
      // Even if navigation is "duplicated", the event handler will trigger reload
      this.$router.push({ query: nextQuery }).catch(err => {
        // Ignore navigation duplicated errors - emit event will trigger reload
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        } else {
          // If navigation is duplicated, still emit event to trigger reload
          this.$emit('search', nextQuery);
        }
      });
    },

    getPublisher(publisher_id) {
      this.$emit("close-entity-menu");
      this.$router.push({ name: "entity", params: { id: publisher_id } });
    },

    lookup(terms) {
      // Lazily load input items
      this.isLoading = true;
      autocomplete(this.search_terms, "publisher")
        .then(data => {
          data.unshift({ key: terms }); 
          this.items = data;
        })
        .finally(() => (this.isLoading = false));
    },

    disabled() {
      if (localStorage.getItem("isLoggedIn") == "1") {
        this.disable_nav = false;
        return this.disable_nav;
      } else {
        this.disable_nav = true;
        return this.disable_nav;
      }
    }
  }
};
</script>

<style scoped>
.publisher-search-wrapper {
  display: flex;
  flex-direction: column;
}

.search-combobox {
  flex: 1;
}
</style>
